import wixLocationFrontend from 'wix-location-frontend';
import wixWindowFrontend from 'wix-window-frontend';

export async function handleCopyProcess(template) {
    $w(`#template${template}CopyBtn`).onClick((event) => {
        $w(`#template${template}CopyBtn`).disable();
        const originalLabel = $w(`#template${template}CopyBtn`).label;
        wixWindowFrontend.copyToClipboard(wixLocationFrontend.url)
            .then(async () => {
                $w(`#template${template}CopyBtn`).label = $widget.props.copiedStateBtnLabel;

                setTimeout(() => {
                    $w(`#template${template}CopyBtn`).label = originalLabel;
                    $w(`#template${template}CopyBtn`).enable();
                }, 1000);
            })
            .catch((err) => {
                // Handle error
                console.error(err);
                $w(`#template${template}CopyBtn`).label = originalLabel;
                $w(`#template${template}CopyBtn`).enable();
            });
    });
}